import Signin from '../components/SignIn/SignIn';

const SigninPage = () => {
  return <Signin />;
};

export default SigninPage;
